import * as _ from 'lodash';
import { Utils } from "../Utils/Utils";
import { StringUtils } from "../Utils/StringUtils";
import {WidgetApiBase} from './WidgetBase';

export class ModalApi extends WidgetApiBase {
    private _modal: JQuery;

    constructor(id: string) {
        super(id);
    }

    protected getInitOptions(): Object {
        return null;
    }

    protected getModal(doInit: boolean = false): JQuery {
        if (!this._modal) {
            var opt = doInit ? this.getInitOptions() : undefined;
            this._modal = this.jq.modal(opt);
        }
        return this._modal;
    }

    protected callApi(method: string): void {
        this.getModal();
        this.jq.modal(method);
    }

    public show(): void {
        this.callApi('show');
    }

    public hide(): void {
        this.callApi('hide');
    }

    public toggle(): void {
        this.callApi('toggle');
    }

    public update(): void {
        this.callApi('handleUpdate');
    }

    public updateTitle(title: string): void {
        let modalTitle = this.jq.find('.modal-title');
        modalTitle.text(title);
    }

    public updateBody(body: string): void {
        let modalBody = this.jq.find('.modal-body');
        modalBody.html(body);
    }
}

export interface ModalOptions {
    /**
     * Closes the modal when escape key is pressed. Default true.
     */
    keyboard: boolean;

    /**
     * Shows the modal when initialized. Default true.
     */
    show: boolean;
}

export class Modal extends ModalApi {
    private _options: ModalOptions;

    constructor(id: string, options: ModalOptions) {
        super(id);
        this._options = options;
        this.getModal(true);
    }

    protected getInitOptions(): Object {
        let o = this._options;

        return {
            backdrop: true,
            keyboard: o.keyboard,
            show: o.show
        };
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Widgets/Modal.ts
 **/